/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.1.15",
    versionName: "0.2.0-nightly.2026.1.15",
    versionChannel: "nightly",
    buildDate: "2026-01-15T00:07:58.620Z",
    commitHash: "a3683a0e58f845c13d9e5f76f905bb035fa936da",
};
